<template>
  <div id="app">
    <Navbar></Navbar>

    <transition :name="transitionName" mode="out-in">
      <router-view/>
    </transition>

    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer  from '@/components/Footer.vue';

export default {
  components: {
    Navbar, Footer
  },
  data () {
    return { transitionName: null }
  },
  mounted () {
    this.$store.dispatch('getPrismicData', this.$prismic)
  },
  watch: {
    '$route' (to, from) {
      window.scrollTo(0, 0);

      if (from.path.includes('projects')) {
        this.transitionName = 'page-transition-out';
      } else {
        this.transitionName = 'page-transition-in';
      }
    }
  }
}
</script>

<style lang="scss">
@import '/assets/scss/base.scss';

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

#nav {
  padding: 30px;
  .link {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>



<style lang="scss" scoped>

   

</style>
